import React from 'react';
import { Section } from './Section';
export function HowItWorks() {
  const phases = [{
    num: '01',
    title: 'Fase de Desensibilización',
    desc: 'Durante la primera semana, aislamos el estímulo para romper el arco reflejo tradicional.'
  }, {
    num: '02',
    title: 'Fase de Recalibración',
    desc: "Integramos técnicas respiratorias avanzadas para subir tu 'umbral de disparo'."
  }, {
    num: '03',
    title: 'Fase de Integración',
    desc: 'Aplicas el nuevo cableado nervioso en encuentros reales con control total del cronómetro.'
  }];
  return <Section darker data-id="element-111">
      <h2 className="font-display font-bold text-3xl md:text-5xl mb-12 text-center uppercase tracking-tight" data-id="element-112">
        Cómo funciona el proceso
      </h2>

      <div className="space-y-8 max-w-3xl mx-auto relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-brand-gray/30" data-id="element-113">
        {phases.map((phase, index) => <div key={index} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-114">
            <div className="flex items-center justify-center w-12 h-12 rounded-none border-2 border-brand-blue bg-brand-dark text-brand-blue font-display font-bold text-xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_10px_rgba(59,130,246,0.2)] z-10" data-id="element-115">
              {phase.num}
            </div>

            <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 bg-brand-gray/10 border border-brand-gray/30" data-id="element-116">
              <h3 className="font-display font-bold text-xl md:text-2xl mb-2 uppercase text-white" data-id="element-117">
                {phase.title}
              </h3>
              <p className="text-gray-400 text-lg" data-id="element-118">{phase.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}